<template>
  <b-modal
    ok-title="Zapisz"
    cancel-title="Anuluj"
    ok-variant="outline-primary"
    cancel-variant="outline-secondary"
    @hidden="close"
    @ok.prevent="addWorkday"
    v-model="localShow"
  >
    <b-row>
      <b-col>
        <b-form-group>
          <span slot="label">Wybierz dzień</span>

          <date-picker
            format="dd.MM.yyyy"
            inputClass="form-control"
            v-model="date"
            :monday-first="true"
            :language="dpLanguage"
          ></date-picker>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="6">
        <b-form-group>
          <span slot="label">Początek pracy</span>

          <time-select v-if="localShow" :set="startToSet" :disabled="!check.start" :display-set-now="true" @time="setStart" />
        </b-form-group>
      </b-col>

      <b-col cols="6">
        <b-form-group>
          <span slot="label">
            Koniec pracy
            <b-checkbox v-model="check.end" class="float-right"></b-checkbox>
          </span>

          <time-select v-if="localShow" :set="end" :disabled="!check.end" :display-set-now="true" @time="setEnd" />
        </b-form-group>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>
import DatePicker from 'vuejs-datepicker';
import { pl } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';

import TimeSelect from '@/components/TimeSelect';
import { WorkdayResource } from '@/resources/workday.resource';

export default {
  components: { DatePicker, TimeSelect },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    cardNumber: {
      type: String
    },
    startTimetable: {
      type: Number,
      required: true,
      default: 480
    }
  },
  data() {
    return {
      dpLanguage: pl,
      check: { start: true, end: false },
      start: null,
      end: null,
      date: new Date(),
      localShow: false
    };
  },
  methods: {
    async addWorkday() {
      try {
        let wdstart = null;
        let wdend = null;
        if (this.check.start) {
          wdstart = this.parseTime(this.start);
        }
        if (this.check.end) {
          wdend = this.parseTime(this.end);
        }
        const wd = await WorkdayResource.addWorkday(this.date, this.cardNumber, wdstart, wdend);
        this.$emit('created', wd);
        this.close();
      } catch (error) {
        this.$notify({ type: 'error', title: 'Błąd!', text: 'Wystąpił błąd.' });
        console.warn(error);
      }
    },
    setStart(value) {
      this.start = value;
    },
    setEnd(value) {
      this.end = value;
    },
    parseTime(time) {
      if (!time) {
        return 0;
      }
      const split = time.split(':').map(n => parseInt(n, 10));
      return split[0] * 60 + split[1];
    },
    close() {
      this.check = { start: true, end: false };
      this.start = null;
      this.end = null;
      this.date = new Date();
      this.$emit('close');
    }
  },
  watch: {
    show(value) {
      this.localShow = value;
    }
  },
  computed: {
    startToSet() {
      const hh = Math.floor(this.startTimetable / 60);
      const mm = this.startTimetable % 60;
      return `${hh}:${mm}`;
    }
  }
};
</script>
